import script from "./SearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=f7ed3bb2&lang=css"

const __exports__ = script;

export default __exports__